export default {
  menu: "菜单",
  nav1: {
    title: "产品",
    itemTitle1: "桌面话机",
    item11: "Halo 系列",
    item12: "Myriad 系列",
    item13: "CE系列",
    item14: "会议电话",
    item15: "耳机",
    item16: "附件",
    itemTitle2: "耳机",
    itemTitle3: "附件",
    itemTitle4: "部署工具",
  },
  nav2: {
    title: "行业应用",
    item1: "企业语音自建",
    item2: "IP 呼叫中心解决方案",
    item3: "公共事业",
    item4: "酒店方案",
  },
  nav3: {
    title: "合作伙伴",
    item1: "技术合作伙伴",
    item2: "成为我们的合作伙伴",
  },
  nav4: {
    title: "服务与支持",
    item1: "热门回答",
    item2: "下载中心",
    item3: "问题反馈",
  },
  nav5: {
    title: "公司",
    item1: "关于我们",
    item2: "热门资讯及市场活动",
  },
};
